shvenergy.foreignIpRedirect = (function ($) {
	"use strict";

	function init() {

		if (!$("#redirectPopupContent").length)
			return;


		var contextId = $("#redirectPopupContent").data("contextid");

		//console.log("ContextId: ", contextId);

		if (contextId === "")
			return;


		//console.log("API Url: " + "/api/foreignipredirect/getcookie/{" + contextId + "}");


		function buildMarkup(data) {

			var header = "";
			var continueButtonTrackingId = "";
			var redirectButtonTrackingId = "";
			

			if (data.Model.Header && data.Model.Header !== "") {
				header = `<h2>${data.Model.Header}</h2>`;
			}

			if (data.Model.ContinueButtonTrackingId && data.Model.ContinueButtonTrackingId !== "") {
				continueButtonTrackingId = `id="${data.Model.ContinueButtonTrackingId}"`;
			}

			if (data.Model.RedirectButtonTrackingId && data.Model.RedirectButtonTrackingId !== "") {
				redirectButtonTrackingId = `id="${data.Model.RedirectButtonTrackingId}"`;
			}

			return `<div class="u-text-center">
				${header}

				${data.Model.BodyCopy}

	            <p class="u-margin-bottom-none">

	                <button type="button" class="button button--hollow u-margin-top-small" onclick="if (shvenergy.cookies.hasCookieCategoryConsent('${data.Model.CookieName}')) { shvenergy.cookies.setCookie('${data.Model.CookieName}', 'seen', 30) }; shvenergy.modal.hideModal();" ${continueButtonTrackingId}>
	                    <span>${data.Model.ContinueButtonText}</span>
	                </button>

	                <a href="${data.Model.RedirectToThisUrl}" class="button u-margin-top-small" ${redirectButtonTrackingId}>
	                    <span>${data.Model.RedirectButtonText}</span>
	                </a>

	            </p>
	        </div>`;
		}

		const request = $.ajax({
			type: "GET",
			url: `/api/foreignipredirect/getcookie/${contextId}`,
			contentType: "application/json; charset=utf-8",
			dataType: "json"
		});
		request.done(function (data) {
			console.log("Data: ", data)
			console.log("Model: ", data.Model)
			console.log("status: ", data.Status)
			if (data.Status === true || data.Status === "true") {

				//console.log("Model: ", data.Model);


				const cookieName = data.Model.CookieName;
				console.log(cookieName);

				if (shvenergy.cookies.hasCookieCategoryConsent(cookieName)) {

					if (shvenergy.cookies.getCookie(cookieName)) {
						var elem = document.getElementById('redirectPopupContent');
						elem.parentNode.removeChild(elem);
						return;
					} else {
						var markup = buildMarkup(data);
						//console.log(markup);
						$("#redirectPopupContent").html(markup);
						shvenergy.modal.showModal(document.getElementById("redirectPopupContent").innerHTML);
					}

				}

			} else {
				//console.log("FALSE");
			}

		});
		request.fail(function (jqXhr, error, errorThrown) {
			//console.log(jqXhr);
			//console.log(jqXhr.responseJSON.Message);
			//console.log(error);
			//console.log(errorThrown);
		});
		request.always(function () {
			//console.log("Always");
		});

	}

	init();

})(jQuery);